import { BulkDeviceEditSample } from "fleet/view/device/bulk-device-edit-sample";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import {
  BULK_DOWNLOAD_DEVICE,
  BULK_DOWNLOAD_DEVICE_CUSTOM,
} from "redux-store/devices/actions";
import { addErrorMessageAction } from "redux-store/messages";

function mapDispatchToProps(dispatch) {
  return {
    addErrorMessage: (message) => {
      dispatch(addErrorMessageAction(message));
    },
    bulkDownload: () => {
      return createPromiseApiAction(dispatch, BULK_DOWNLOAD_DEVICE);
    },
    bulkCustomDownload: (serviceArgs) => {
      const { appParams, flags, properties, targets } = serviceArgs;
      return createPromiseApiAction(dispatch, BULK_DOWNLOAD_DEVICE_CUSTOM, [
        appParams,
        flags,
        properties,
        targets,
      ]);
    },
  };
}

const ConnectedBulkDeviceEditSample = connect(
  null,
  mapDispatchToProps,
)(BulkDeviceEditSample);

export { ConnectedBulkDeviceEditSample };
